<homey-text-page>
  <div>
    <homey-page-title title="Privacy policy"/>
    <div class="flex flex-col gap-4">
      <p>
        This Privacy Policy applies to the Homey - NYC Housing Lottery Made Easy mobile application (hereinafter
        referred to
        as the “Application”) developed by Homey Affordable Housing, Inc. (hereinafter referred to as the “Service
        Provider”). The Application is provided as a commercial service and is intended for use “AS IS”.
      </p>
      <p> By using the Application, you consent to the data practices described in this Privacy Policy.</p>

      <homey-paragraphs>
        <div>
          <homey-page-subtitle title="1. Information Collection and Use"/>
          <homey-h3>1.1 Data We Collect</homey-h3>
          <p>The Application collects data in two ways: (i) data you provide directly and (ii) data automatically
            collected when you use the Application.</p>
        </div>
        <div>
          <homey-h4>A. Information You Provide</homey-h4>
          <p>To submit housing applications on your behalf, the Application may require you to provide personally
            identifiable information, including but not limited to:</p>
        </div>
        <homey-bullet-list>
          <li>Full name</li>
          <li>Date of birth</li>
          <li>Home address & previous address</li>
          <li>Email address</li>
          <li>Income & Employment information</li>
          <li>Personal asset information</li>
          <li>Household size & details (including information on minors)</li>
          <li>Disability information</li>
          <li>Gender & Pronouns</li>
        </homey-bullet-list>
        <div>
          <homey-h4>B. Information Automatically Collected</homey-h4>
          <p>When you use the Application, we may automatically collect:</p>
        </div>
        <homey-bullet-list>
          <li>Device Information: Operating system, device model, and unique device identifiers.</li>
          <li>Usage Data: Pages visited, time and date of visits, time spent on pages, and in-app interactions.</li>
          <li>IP Address: To monitor traffic patterns and prevent fraudulent activities.</li>
          <li>Location Information: The Application does not collect precise location data from your mobile device.</li>
        </homey-bullet-list>
        <div>
          <homey-page-subtitle title="2. How We Use and Share Your Data"/>
          <p>The Service Provider collects and processes data to:</p>
        </div>
        <homey-bullet-list>
          <li>Facilitate and manage your applications for NYC housing lotteries.</li>
          <li>Pre-fill and submit applications on your behalf to NYC Housing Connect and other relevant housing
            agencies.
          </li>
          <li>Provide customer support and respond to inquiries.</li>
          <li>Send important notices, updates, and promotional content.</li>
          <li>Ensure compliance with applicable laws and regulations.</li>
          <li>Enhance security, detect fraud, and prevent abuse.</li>
        </homey-bullet-list>
        <div>
          <homey-h3>2.1 Data Sharing with NYC Housing Connect</homey-h3>
          <p>To complete your housing applications, we share certain user-provided information with NYC Housing Connect
            (the official New York City affordable housing portal). This includes:</p>
        </div>
        <homey-bullet-list>
          <li>Personal details such as name, date of birth, and contact information</li>
          <li>Household information, including household size, dependents, and income details</li>
          <li>Employment and financial details as required by NYC Housing Connect applications</li>
        </homey-bullet-list>
        <p>By using this Application, you consent to Homey submitting this data on your behalf to NYC Housing
          Connect.</p>
      </homey-paragraphs>
      <div>
        <homey-page-subtitle title="3. Third-Party Data Sharing"></homey-page-subtitle>
        <homey-h3>3.1 Third-Party Service Providers</homey-h3>
        <p>Beyond NYC Housing Connect, we may share anonymized or aggregated data with third-party services to improve
          our Application. These include:</p>
      </div>
      <homey-bullet-list>
        <li>Google Play Services (for app distribution and updates)</li>
        <li>Analytics Providers (for performance tracking and user behavior analysis)</li>
        <li>Cloud Storage Services (for secure data hosting)</li>
      </homey-bullet-list>
      <p>Each third-party provider has its own Privacy Policy regarding data handling. We encourage you to review their
        policies:</p>
      <homey-bullet-list>
        <li><a href="https://policies.google.com/privacy" class="underline">Google Play Services</a></li>
      </homey-bullet-list>
      <div>
        <homey-h3>3.2 Other Disclosures</homey-h3>
        <p>We do not sell or rent your personal data. However, we may share information in the following cases:</p>
      </div>
      <homey-bullet-list>
        <li>Legal Compliance: To comply with a legal obligation, court order, or government request.</li>
        <li>Fraud Prevention & Security: If necessary to prevent fraud, security threats, or harm to users.</li>
        <li>Service Providers: With trusted third-party partners who process data on our behalf, under confidentiality
          agreements.
        </li>
      </homey-bullet-list>
      <div>
        <homey-page-subtitle title="4. Your Rights & Choices"></homey-page-subtitle>
        <homey-h3>4.1 Opt-Out Rights</homey-h3>
        <p>You can stop all data collection by uninstalling the Application. Uninstallation can be done through your
          device’s standard processes or via the app marketplace.</p>
      </div>
      <div>
        <homey-h3>4.2 Data Access & Deletion Requests</homey-h3>
        <p>You have the right to:</p>
      </div>
      <homey-bullet-list>
        <li>Request access to the personal data we hold about you.</li>
        <li>Request corrections or updates to your information.</li>
        <li>Request deletion of your personal data.</li>
      </homey-bullet-list>
      <p>To exercise these rights, please contact us at contact&#64;myhomey.io. We will process your request within a
        reasonable timeframe, except for data already submitted to NYC Housing Connect, as we do not control their data
        retention policies.</p>
      <div>
        <homey-page-subtitle title="5. Data Retention Policy"></homey-page-subtitle>
        <p>We retain your personal data only as long as necessary to provide our services and comply with legal
          obligations. Upon request, we will delete your data unless retention is required by law.</p>
      </div>
      <div>
        <homey-page-subtitle title="6. Security Measures"></homey-page-subtitle>
        <p>The Service Provider takes data security seriously. We implement physical, electronic, and procedural
          safeguards to protect your data from unauthorized access, disclosure, or loss. While we strive to use
          commercially acceptable means to protect your personal data, no method of transmission over the internet is
          100% secure.</p>
      </div>
      <div>
        <homey-page-subtitle title="7. Children's Privacy"></homey-page-subtitle>
        <p>The Application is not intended for use by children under 13 years of age, and we do not knowingly allow them
          to create accounts or provide personal data independently.</p>
      </div>
      <p>However, as part of the application process, users may need to provide information about household members
        under the age of 13. This information is collected only for the purpose of housing applications and is protected
        under this Privacy Policy.</p>
      <p>If we become aware that a child under 13 has provided personal information independently, we will delete such
        data immediately. If you believe a child has provided us with personal data outside of a household application,
        please contact us at contact&#64;myhomey.io.</p>
      <div>
        <homey-page-subtitle title="8. Changes to This Privacy Policy"></homey-page-subtitle>
        <p>We may update this Privacy Policy from time to time. Changes will be posted within the Application and
          updated on our official website.</p>
      </div>
      <p>How We Notify You of Changes:</p>
      <homey-bullet-list>
        <li>Significant changes will be communicated via in-app notifications or email.</li>
        <li>Continued use of the Application after changes means you accept the updated policy.</li>
      </homey-bullet-list>
      <div>
        <homey-page-subtitle title="9. Contact Us"></homey-page-subtitle>
        <p>For questions about this Privacy Policy or data practices, please contact us:</p>
      </div>
      <div>
        <p>Email: contact&#64;myhomey.io</p>
        <p>Company: Homey Affordable Housing, Inc</p>
      </div>
    </div>
  </div>
</homey-text-page>
